import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { useLocalization } from "../../hooks/useLocalization";
import { onboardingApi } from "../../services/onboardingApi";
import { RequirementChecklist } from "../../components/RequirementChecklist";
import { OnboardingProgress } from "../../components/OnboardingProgress";
import { StatusBadge } from "../../components/StatusBadge";
import { EagleState } from "../../components/EagleState";
import { PageHelpBanner } from "../../components/PageHelpBanner";
import { COMPLETE_STATUSES } from "../../lib/onboardingConstants";

export default function MyOnboardingPage() {
  const { user } = useAuth();
  const { t } = useLocalization();
  const [onboardingCase, setOnboardingCase] = useState(null);

  useEffect(() => {
    if (user?.employee_id) {
      onboardingApi.getCaseByEmployee(user.employee_id).then((r) => setOnboardingCase(r.data)).catch(() => {});
    }
  }, [user]);

  if (!onboardingCase) return <p className="text-sm text-gray-500">{t("common.noData")}</p>;

  const allComplete = onboardingCase.requirements.every((r) => COMPLETE_STATUSES.includes(r.status));

  return (
    <div data-testid="my-onboarding-page" className="space-y-5">
      <PageHelpBanner pageKey="my-onboarding" title="How to use this page">
        <p>Every requirement you need to complete before you're cleared to work is listed below - upload documents where needed and HR will review and check them off.</p>
      </PageHelpBanner>
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("onboarding.checklist")}</h2>
        <StatusBadge status={onboardingCase.status} />
      </div>
      {allComplete ? (
        <EagleState variant="success" title={t("eagle.noOutstandingTasksTitle")} message={t("eagle.noOutstandingTasksMessage")} testId="onboarding-all-complete" />
      ) : (
        <div className="bg-white rounded-2xl border border-gray-200 p-5">
          <OnboardingProgress requirements={onboardingCase.requirements} />
        </div>
      )}
      <RequirementChecklist requirements={onboardingCase.requirements} canReview={false} onUpdateStatus={async () => {}} />
    </div>
  );
}
